<template>
  <div class="widget-card-content">
    <h2 class="content-title">{{title}}</h2>

    <div v-if="warning" class="warning-content bordered">
      <h3 v-if="warning.title" class="warning-content-title bold">
        {{warning.title}}
      </h3>
      <p
          v-if="warning.text"
          class="warning-content-text"
      >
        {{warning.text}}
      </p>
    </div>

    <p v-if="text" class="widget-card-description">{{text}}</p>
  </div>
</template>

<script>

export default {
  name: 'WidgetCardAchInfo',
  props: {
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    warning: {
      text: {
        type: String,
        default: null,
      },
    },
  },
};
</script>

<style lang="stylus" scoped>
.warning-content {
  margin-top: 30px;
  &.bordered {
    padding-left: 20px;
    border-left: #DE4B4B solid 3px;
    @media (max-width 480px) {
      margin-top: 52px;
      border-width: 2px;
      padding-left: 16px;
    }
  }
  & .warning-content-text {
    color: #525F66;
  }
}
</style>
